var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 320,
    viewBox: "0 0 360 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153.159 15.3294L4.11051 273.469C1.41818 278.131 0.000498294 283.419 1.31333e-07 288.803C-0.000498031 294.186 1.4162 299.474 4.10767 304.136C6.79914 308.799 10.6705 312.67 15.3326 315.362C19.9947 318.053 25.2833 319.47 30.6665 319.469H328.739C334.122 319.47 339.41 318.053 344.072 315.362C348.734 312.67 352.606 308.799 355.297 304.136C357.989 299.474 359.406 294.186 359.405 288.803C359.405 283.419 357.987 278.131 355.295 273.469L206.263 15.3294C203.571 10.6687 199.701 6.79836 195.04 4.10749C190.379 1.41662 185.092 0 179.711 0C174.329 0 169.042 1.41662 164.381 4.10749C159.72 6.79836 155.85 10.6687 153.159 15.3294Z",
    fill: "#E75C5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M181.658 94.9453H177.77C168.197 94.9453 160.438 102.705 160.438 112.277V195.121C160.438 204.694 168.197 212.453 177.77 212.453H181.658C191.23 212.453 198.99 204.694 198.99 195.121V112.277C198.99 102.705 191.23 94.9453 181.658 94.9453Z",
    fill: "#FFF7ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M179.714 278.157C190.359 278.157 198.99 269.527 198.99 258.881C198.99 248.236 190.359 239.605 179.714 239.605C169.068 239.605 160.438 248.236 160.438 258.881C160.438 269.527 169.068 278.157 179.714 278.157Z",
    fill: "#FFF7ED"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert1);
export default __webpack_public_path__ + "static/media/Alert-1.fc7e24ab.svg";
export { ForwardRef as ReactComponent };